export const FileUploadIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1269_18374)">
        <path
          d="M25.0002 28H7.00024C6.73503 28 6.48067 27.8946 6.29314 27.7071C6.1056 27.5196 6.00024 27.2652 6.00024 27V5C6.00024 4.73478 6.1056 4.48043 6.29314 4.29289C6.48067 4.10536 6.73503 4 7.00024 4H19.0002L26.0002 11V27C26.0002 27.2652 25.8949 27.5196 25.7074 27.7071C25.5198 27.8946 25.2655 28 25.0002 28Z"
          stroke="#D4002A"
          strokeWidth="1.96923"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0005 4V11H26.0005"
          stroke="#D4002A"
          strokeWidth="1.96923"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1269_18374">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
